import { Common } from '../models/redux/store';
import { CommonActionTypes } from '../models/redux/actions';
import * as actionNames from '../models/redux/actions/names';

const initialState: Common = {
  quillToast: {
    isShown: false,
  },
  theme: 'default',
  maintenance: {
    isMaintenance: false,
    globalMaintenance: {
      enabled: false,
    },
    barMessage: 'We are currently performing an upgrade, so performance might be unstable',
    alertMessage: 'QuillBot is currently down for maintenance. Check back soon.',
    alertTitle: 'QuillBot Under Maintenance',
    countryWiseMaintenanceCheck: {},
  },
  platform: {
    isMobile: false,
    isDesktop: false,
    isAndroid: false,
    isIos: false,
    isIPhone: false,
    isOperaMobile: false,
    isChrome: false,
    isEdge: false,
    isOpera: false,
    isFirefox: false,
    isSafari: false,
    isIE: false,
    isExtension: false,
    isMac: false,
    isTablet: false,
  },
  language: '',
  recaptcha: {
    isShown: false,
  },
  isKeyboardOpen: false,
  session: {
    isShown: false,
  },
  isOpenSignUpModel: false,
  exportedImages: [],
  // ipData: {},
  paraphraserReceivedOtherProductData: null,
  showSignUpModal: false,
  countryCode: '',
  independentTool: false,
  regionalLanguage: 'us',
  spamCheckCallCompleted: false,
  sidebarPinned: false,
  partnerCompany: '',
  AbTestExperiments: {},
  AbTestExperimentsInfo: {},
  crossProductUpsell: null,
  appLanguage: 'EN',
  hideSessionManager: false,
  userClickedThemeBtn: false,
  userClickedLogOutBtn: false,
};

function reducer(state: Common = initialState, action: CommonActionTypes): Common {
  switch (action.type) {
    case actionNames.UI_TOGGLE_DRAWER:
      return {
        ...state,
        isOpencompareModeDrawer: false,
        quillDrawer: action.payload,
      };
    case actionNames.COMPARE_TOGGLE_DRAWER:
      if (action.payload) {
        return {
          ...state,
          quillDrawer: null,
          isOpencompareModeDrawer: action.payload,
        };
      }
      return {
        ...state,
        isOpencompareModeDrawer: action.payload,
      };
    case actionNames.TOGGLE_SIGNUP_MODEL:
      return {
        ...state,
        isOpenSignUpModel: action.payload,
      };
    case actionNames.UI_SHOW_ALERT: {
      return {
        ...state,
        alertDialog: { ...action.payload },
      };
    }
    case actionNames.UI_TOGGLE_TOAST:
      return {
        ...state,
        quillToast: action.payload,
      };
    case actionNames.UI_TOGGLE_RECAPTCHA:
      return {
        ...state,
        recaptcha: { ...action.payload },
      };
    case actionNames.UI_TOGGLE_SESSION_DIALOG:
      return {
        ...state,
        session: { ...action.payload },
      };
    case actionNames.SET_PLATFORM:
      return {
        ...state,
        platform: {
          ...state.platform,
          ...action.payload,
        },
      };
    case actionNames.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case actionNames.UI_TOGGLE_KEYBOARD:
      return {
        ...state,
        isKeyboardOpen: action.payload.isOpen,
      };
    case actionNames.SET_EXTENSION_MODE:
      return {
        ...state,
        platform: {
          ...state.platform,
          isExtension: action.payload.activated,
          extensionMetaData: action.payload,
        },
      };
    case actionNames.MAINTENANCE_MODE:
      return {
        ...state,
        maintenance: {
          ...action.payload,
        },
      };

    case actionNames.SET_COUNTRY_CODE:
      return {
        ...state,
        countryCode: action.payload,
      };
    case actionNames.SET_EXPORTED_IMAGES:
      return {
        ...state,
        exportedImages: [...action.payload],
      };
    // case actionNames.SET_IP_DATA:
    //   return {
    //     ...state,
    //     ipData: { ...action.payload },
    //   };
    case actionNames.PARAPHRASER_RECEIVED_OTHER_PRODUCT_DATA:
      return {
        ...state,
        paraphraserReceivedOtherProductData: action.payload.text,
      };
    case actionNames.SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case actionNames.SET_SIGN_UP_MODAL_STATE:
      return {
        ...state,
        showSignUpModal: action.payload,
      };
    case actionNames.SET_INDEPENDENT_TOOL:
      return {
        ...state,
        independentTool: action.payload,
      };

    case actionNames.SET_REGIONAL_LANGUAGE:
      return {
        ...state,
        regionalLanguage: action.payload,
      };

    case actionNames.SET_SPAM_CHECK_CALL_STATUS: {
      return {
        ...state,
        spamCheckCallCompleted: action.payload,
      };
    }

    case actionNames.SET_SIDEBAR_PINNED: {
      return {
        ...state,
        sidebarPinned: action.payload,
      };
    }

    case actionNames.SET_PARTNER_COMPANY: {
      return {
        ...state,
        partnerCompany: action.payload,
      };
    }

    case actionNames.SET_AB_EXPERIMENTS: {
      return {
        ...state,
        AbTestExperiments: action.payload.abExperiments,
        AbTestExperimentsInfo: action.payload.abExperimentsInfo,
      };
    }
    case actionNames.HIDE_SESSION_MANAGER: {
      return {
        ...state,
        hideSessionManager: action.payload,
      };
    }
    case actionNames.USER_CLICKED_LOGOUT_BTN: {
      return {
        ...state,
        userClickedLogOutBtn: action.payload,
      };
    }
    case actionNames.USER_CLICKED_THEME_BTN: {
      return {
        ...state,
        userClickedThemeBtn: action.payload,
      };
    }
    case actionNames.SET_APP_LANGUAGE:
      return {
        ...state,
        appLanguage: action.payload,
      };

    case actionNames.SET_CAMPAIGN:
      return {
        ...state,
        campaign: action.payload,
      };

    default:
      return state;
  }
}

export default reducer;
